import {
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Table,
  Upload,
  UploadProps,
} from 'antd';
import { ColumnsType } from 'antd/es/table';
import { UploadFile } from 'antd/lib';
import { DownloadIcon } from 'assets/svg';
import Button from 'components/Button';
import useQueryParam from 'hooks/useQueryPrams';
import React, { useEffect, useState } from 'react';
import formatNumber from 'utils/formatNumber';
import { HocChangePagination } from 'utils/HocChangePagination';
import { openNotificationWithIcon } from 'utils/notification';
import * as XLSX from 'xlsx';

interface IProps {
  open: boolean;
  setOpen: any;
  listProducts: any;
}

const ModalImportCart = ({ open, setOpen, listProducts }: IProps) => {
  const [selectedFile, setSelectedFile] = useState<UploadFile>();
  const [productImports, setProductImports] = useState<any>([]);
  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size = parseInt(queryParam.get('page_size') + '') || 4;

  function handleUploadFile(info: UploadProps) {
    try {
      if (info.fileList) {
        const files = info.fileList.map((file: any) => {
          return file.originFileObj;
        });
        if (files.length != 0) {
          const file = info.fileList[0];
          setSelectedFile(file);
          const reader = new FileReader();

          reader.onload = (e) => {
            if (e.target) {
              const data = e.target.result;
              const workbook = XLSX.read(data, { type: 'array' });
              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];

              let excelData = XLSX.utils.sheet_to_json<any[]>(worksheet, {
                header: 1,
                range: 0,
              });

              if (
                excelData.length == 0 ||
                excelData[0].length == 0 ||
                excelData[0][0] != 'STT'
              ) {
                openNotificationWithIcon(
                  'error',
                  'File không đúng mẫu, vui lòng tải mẫu'
                );
                return;
              }
              excelData = excelData.slice(1);

              const products: any[] = [];
              excelData.forEach((row, index) => {
                const product: any = {};
                if (row.length != 0) {
                  for (let index = 0; index < row.length; index++) {
                    const value = row[index];
                    product[columns[index].dataIndex] =
                      value == ''
                        ? undefined
                        : columns[index].dataIndex == 'order_min' ||
                          columns[index].dataIndex == 'order_max'
                        ? Number(value)
                        : value;
                  }
                  products.push(product);
                }
              });

              setProductImports(products);
            }
          };
          const blob = file.originFileObj as Blob;
          reader.readAsArrayBuffer(blob);
        }
      }
    } catch (err) {
      openNotificationWithIcon('error', 'File không đúng định dạng mẫu');
    }
  }
  const handleCopyCart = () => {
    if (productImports.length == 0) {
      openNotificationWithIcon('error', 'Bạn chưa import mã mẫu');
      return;
    }
    setOpen(false);
    listProducts(productImports);
    setProductImports([]);
  };

  const handleCancel = () => {
    setProductImports([]);
    setOpen(false);
  };

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'ma_mau',
      width: 60,
      render: (text, record, index) =>
        productImports.findIndex(
          (product: any) => product.ma_mau === record.ma_mau
        ) + 1,
    },
    {
      title: 'Mã mẫu',
      dataIndex: 'ma_mau',
    },
    {
      title: 'Order min',
      dataIndex: 'order_min',
    },
    {
      title: 'Order max',
      dataIndex: 'order_max',
    },
  ];

  function generateExcel() {
    const data = [];
    const headerRow = columns.map((column) => {
      return column.title;
    });
    data.push(headerRow);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, `import_mau.xlsx`);
  }

  return (
    <Modal
      cancelText="Huỷ"
      okText="Lưu"
      closeIcon={false}
      open={open}
      onOk={handleCopyCart}
      onCancel={handleCancel}
      width={'70%'}
    >
      <Col>
        <Row style={{ justifyContent: 'space-between' }}>
          <p style={{ fontWeight: 'bold', fontSize: '16px' }}>Import mẫu</p>
          <Button
            bgColor={'bg-white'}
            color={'text-primary-50'}
            border="border-primary-50"
            onClick={generateExcel}
          >
            Tải mẫu tại đây
            <DownloadIcon />
          </Button>
        </Row>
        <Row
          style={{
            marginBottom: '20px',
            marginTop: '20px',
          }}
        >
          <Input
            disabled={true}
            placeholder="Tải file định dạng .xls, .csv"
            className=""
            value={selectedFile?.name}
            style={{
              marginRight: '20px',
              flex: 1,
            }}
          />

          <Upload
            accept=".xlsx,.xls,.csv"
            onChange={handleUploadFile}
            beforeUpload={() => false}
            fileList={[]}
            showUploadList={false}
          >
            <Button
              bgColor={'bg-white'}
              color={'text-primary-50'}
              border={'border-primary-50'}
              customClass="fix-border-radius"
            >
              Browser
            </Button>
          </Upload>
        </Row>
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          scroll={{ x: 'max-content' }}
          className="customTable"
          dataSource={productImports}
          // pagination={{
          //   current: page,
          //   pageSize: page_size,
          //   total: productImports.length,
          //   showSizeChanger: true,
          //   pageSizeOptions: ['10', '20', '50'],
          //   // onChange: HocChangePagination(history),
          // }}
        />
      </Col>
    </Modal>
  );
};

export default ModalImportCart;
